import React from 'react';

const PopupHeaderTabs = ({ status, setStatus, selSelettore, defSelettore }) => {
  const tabs = [
    { label: 'Info - Conf', value: 0 },
    { label: 'Regioni', value: 1 },
    { label: 'Conf2', value: 2 },
    { label: 'Test', value: 3 },
    { label: 'Vayyar Doc', value: 4 },
  ];

  return (
    <>
      <div id="Header" className="headerPopup" style={{ justifyContent: 'start' }}>
        <div style={{ display: 'flex' }}>
          {tabs.map((tab) => (
            <div
              key={tab.value}
              className={status === tab.value ? selSelettore : defSelettore}
              onClick={() => {
                setStatus(tab.value);
              }
              }
            >
              <p>{tab.label}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default PopupHeaderTabs;
